import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { Settings } from "settings";
import { MonitoringEventTypeType } from "shared/types/monitoring_event";
import { createMonitoringEvent } from "store/reducers/monitoring";
import { selectCurrentUserId } from "store/selectors/local";

function PubsubStatsTask() {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(selectCurrentUserId());

  useEffect(() => {
    const interval = setInterval(() => {
      const stats = window.pubsubStatsCollector.getStats();
      dispatch(
        createMonitoringEvent({
          type: MonitoringEventTypeType.PUBSUB_STATS,
          userId: currentUserId,
          contextData: stats,
        }),
      );
      window.pubsubStatsCollector.resetStats();
    }, Settings.PUBSUB_STATS_COLLECTION_INTERVAL);
    return () => clearInterval(interval);
  }, [dispatch, currentUserId]);

  return null;
}

export { PubsubStatsTask };
